// ─── Side Effects Match — round data ────────────────────────────────────────

export const MATCH_ROUNDS = [
  {
    id: "antibiotics",
    title: "Antibiotics",
    pairs: [
      { id: "amox",   drug: "Amoxicillin",    sideEffect: "Maculopapular rash, diarrhoea, risk of anaphylaxis" },
      { id: "metro",  drug: "Metronidazole",  sideEffect: "Metallic taste, nausea, severe reaction with alcohol" },
      { id: "doxy",   drug: "Doxycycline",    sideEffect: "Photosensitivity, oesophagitis — take upright with plenty of water" },
      { id: "cipro",  drug: "Ciprofloxacin",  sideEffect: "Tendon rupture (Achilles), QT prolongation, avoid under-18s" },
    ],
  },
  {
    id: "cardiovascular",
    title: "Cardiovascular drugs",
    pairs: [
      { id: "ramipril",   drug: "Ramipril",    sideEffect: "Persistent dry cough, hyperkalaemia, angioedema (rare but serious)" },
      { id: "amlodipine", drug: "Amlodipine",  sideEffect: "Ankle swelling, flushing, headache, gingival hyperplasia" },
      { id: "bisoprolol", drug: "Bisoprolol",  sideEffect: "Fatigue, cold extremities, bradycardia, masks hypoglycaemia signs" },
      { id: "simva",      drug: "Simvastatin", sideEffect: "Myopathy / rhabdomyolysis, hepatotoxicity, avoid grapefruit juice" },
    ],
  },
  {
    id: "high-risk",
    title: "High-risk drugs",
    pairs: [
      { id: "warfarin",  drug: "Warfarin",   sideEffect: "Bleeding, many drug/food interactions, requires regular INR monitoring" },
      { id: "lithium",   drug: "Lithium",    sideEffect: "Narrow therapeutic index, tremor, polyuria, requires blood level monitoring" },
      { id: "digoxin",   drug: "Digoxin",    sideEffect: "Yellow-green visual halos, bradycardia, toxicity worsened by hypokalaemia" },
      { id: "furo",      drug: "Furosemide", sideEffect: "Dehydration, hypokalaemia, ototoxicity in high IV doses, gout" },
    ],
  },
  {
    id: "everyday",
    title: "Everyday medications",
    pairs: [
      { id: "ibuprofen",  drug: "Ibuprofen",   sideEffect: "GI ulceration, renal impairment, fluid retention, avoid in 3rd trimester" },
      { id: "codeine",    drug: "Codeine",      sideEffect: "Constipation, nausea, dependence risk, respiratory depression in overdose" },
      { id: "metformin",  drug: "Metformin",    sideEffect: "GI upset (nausea / diarrhoea), lactic acidosis risk, long-term B12 deficiency" },
      { id: "omeprazole", drug: "Omeprazole",   sideEffect: "Hypomagnesaemia (long-term), headache, increased C. diff risk" },
    ],
  },
  {
    id: "psychiatric",
    title: "Psychiatric & neurological",
    pairs: [
      { id: "sertraline",  drug: "Sertraline",       sideEffect: "Initial nausea/agitation, sexual dysfunction, serotonin syndrome, discontinuation syndrome" },
      { id: "amitript",    drug: "Amitriptyline",    sideEffect: "Dry mouth, urinary retention, sedation, weight gain, QT prolongation" },
      { id: "haloperidol", drug: "Haloperidol",      sideEffect: "Extrapyramidal effects (dystonia, parkinsonism, tardive dyskinesia), QT prolongation" },
      { id: "valproate",   drug: "Sodium valproate", sideEffect: "Teratogenic, weight gain, tremor, hepatotoxicity, pancreatitis, hair thinning" },
    ],
  },
];
